import type { ApiProxyClient } from '../../types';
import { handleContactUs } from './contactUs/handleContactUs';

export const customerCareApi: ApiProxyClient['customerCare'] = {
    handleContactUs,
};
